import { Typography } from "@/design-system/Atoms";
import { NotificationList } from "./NotificationList";
import { useNotificationService } from "@/rtkQuery/features/hooks/useNotificationService";
import { AppEmptyState, AppErrorState } from "@/design-system/Feedbacks";
import { DASHBOARD_TABS } from "@/constants/dashboardTabs";
import NotificationTabShimmer from "./NotificationTabShimmer";
import { useScrollToTopOnMount } from "@/hooks/useScrollToTopOnMount";
import { useAuthService } from "@/rtkQuery/features/hooks";

const CenteredWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="w-fit mx-auto px-4">
    <div className="rounded-[20px] min-h-[40vh] lg:min-h-[35vh] flex items-center justify-center">
      {children}
    </div>
  </div> 
);

export const NotificationSection = () => {
  useScrollToTopOnMount();
  const { isAuthenticated } = useAuthService();
  const {
    notificationsData,
    notificationIsLoading,
    notificationIsFetching,
    notificationIsError,
    notificationIsUninitialized,
    refetchNotifications,
  } = useNotificationService();

 
  const shouldShowShimmer =
    !isAuthenticated ||
    notificationIsLoading ||
    notificationIsUninitialized ||
    notificationIsFetching;
 
  const notificationsList = Array.isArray(notificationsData)
    ? notificationsData
    : [];

  const renderContent = () => {
     if (shouldShowShimmer) {
       return <NotificationTabShimmer />;
     }

       if (notificationIsError) {
         return (
           <CenteredWrapper>
             <AppErrorState
               message="Failed to load notifications."
               onRetry={refetchNotifications}
             />
           </CenteredWrapper>
         );
       }

    if (notificationsList.length === 0) {
      return (
        <CenteredWrapper>
          <AppEmptyState message="No notifications found." />
        </CenteredWrapper>
      );
    }

       return <NotificationList data={notificationsList} />;
     };

  return (
    <div className="rounded-[20px] bg-[#f6f7f9] p-8" id="v-pills-tabContent">
      <div
        id={DASHBOARD_TABS.NOTIFICATION}
        role="tabpanel"
        aria-labelledby={DASHBOARD_TABS.NOTIFICATION}
        className=" block opacity-100"
      >
        <Typography variant="darkBackgroundHeading" as="h3" className="animate-fade-in-up">
          Notifications
        </Typography>

        {renderContent()}
      </div>
    </div>
  );
};
export default NotificationSection;
